import Text from 'components/Text';
import { ModalNumberCustomersCustom, useModalNumberCustomersCustomRef } from './ModalNumberCustomersCustom';
import { styled } from 'styled-components';

interface NumberCustomersCustomProps {
  value?: number;
  onChange?: (value: number) => void;
}

const NumberCustomersCustom = ({ value, onChange }: NumberCustomersCustomProps) => {
  const modalRef = useModalNumberCustomersCustomRef();
  return (
    <CustomBox className={`${value && value > 10 ? 'active' : ''}`}>
      <button type='button' onClick={() => modalRef.current?.open()}>
        <Text variant='CONTENT_2' className='active-text'>Custom {value && value > 10 ? ` (${value})` : ''}</Text>
      </button>
      <ModalNumberCustomersCustom ref={modalRef} onSubmit={(o) => onChange?.(o)} />
    </CustomBox>
  );
};

export default NumberCustomersCustom;

const CustomBox = styled.div`
  height: 46px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  background: #fff;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.08);
  grid-column: 5 / span 2;
  display: flex;
  align-items: center;
  justify-content: center;

  > button {
    width: 100%;
    height: 100%;
 }
    
  &.active {
    background: #2d67f2;
    .active-text {
      color: #fff;
    }
  }
`;
